import React from 'react';
import { Input } from 'reactstrap';

import { getSelectClassName } from '~support-at-home/lib/contributionSelection';

interface ComponentProps {
  id: string;
  label: string;
  checked: boolean;
  // Some, but not all, of a client's contributions are selected.
  indeterminate?: boolean;
  // Whether anything at all is selected: while it is, every checkbox stays drawn.
  anySelected: boolean;
  onChange: () => void;
  disabled?: boolean;
}

// The selection checkbox in the first cell. Always occupies its slot; when it is drawn is decided in
// CSS from the class returned by getSelectClassName (plus row hover).
const ContributionSelectCheckbox: React.FC<ComponentProps> = ({
  id,
  label,
  checked,
  indeterminate = false,
  anySelected,
  onChange,
  disabled = false,
}) => (
  <span className={getSelectClassName(checked, anySelected)}>
    <Input
      type="checkbox"
      id={id}
      checked={checked}
      disabled={disabled}
      onChange={onChange}
      aria-label={label}
      innerRef={(el: HTMLInputElement | null) => {
        // `indeterminate` is a DOM property with no attribute, so it is set on the element.
        if (el) el.indeterminate = indeterminate;
      }}
    />
  </span>
);

// An empty slot of the same width, for a row that cannot be selected, so its text still lines up.
export const SelectSlotPlaceholder = () => <span className="contribution-select-placeholder" aria-hidden="true" />;

export default ContributionSelectCheckbox;
